import React, { Fragment, useEffect, useState } from "react";
import { Row, Table, Button, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { Input } from "reactstrap";
import {
  // Column,
  // Table as ReactTable,
  // ColumnFiltersState,
  // FilterFn,
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender
} from '@tanstack/react-table';

import { rankItem } from '@tanstack/match-sorter-utils';
import JobListGlobalFilter from "./GlobalSearchFilter";
import PageClickConfirmModal from "./PageClickConfirmModal";

// Column Filter
const Filter = ({
  column
}) => {
  const columnFilterValue = column.getFilterValue();

  return (
    <>
      <DebouncedInput
        type="text"
        value={(columnFilterValue ?? '')}
        onChange={value => column.setFilterValue(value)}
        placeholder="Search..."
        className="w-36 border shadow rounded"
        list={column.id + 'list'}
      />
      <div className="h-1" />
    </>
  );
};

// Global Filter
const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return (
    <React.Fragment>
      <Col sm={4}>
        <input {...props} value={value} onChange={e => setValue(e.target.value)} />
      </Col>
    </React.Fragment>
  );
};

const PaginationTableContainer = ({
  columns,
  data,
  tableClass,
  theadClass,
  divClassName,
  isBordered,
  isPagination,
  isGlobalFilter,
  paginationWrapper,
  SearchPlaceholder,
  pagination,
  buttonClass,
  buttonName,
  isAddButton,
  isCustomPageSize,
  pageSize,
  handleUserClick,
  isJobListGlobalFilter,
  totalLength,
  setCurrent,
  onLimitChange,
  initialPageIndex
  // setLimit

}) => {

  const [columnFilters, setColumnFilters] = useState([]);
  // Optional: lets a caller restore the page the user was previously on (e.g. after
  // navigating away to edit a row and back). Defaults to 0 - unused by callers that
  // don't pass it, so existing pages keep their current behavior unchanged.
  const [currentPage, setCurrentPage] = useState(initialPageIndex || 0); // Current page index
  const [globalFilter, setGlobalFilter] = useState('');
  const [pagesToShow, setPagesToShow] = useState(5);

  const [limit, setLimit] = useState(5);
  const [submitModal, setSubmitModal] = useState(false);



  const fuzzyFilter = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value);
    addMeta({
      itemRank
    });
    return itemRank.passed;
  };

  const table = useReactTable({
    columns,
    data,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      columnFilters,
      globalFilter,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const {
    getHeaderGroups,
    getRowModel,
    getCanPreviousPage,
    getCanNextPage,
    getPageOptions,
    // setPageIndex,
    nextPage,
    previousPage,
    setPageSize,
    getState,

  } = table;
  const [pageIndex, setPageIndex] = useState(initialPageIndex || 0);
  const [lastAction, setLastAction] = useState(null);
  const [lastGotoEvent, setLastGotoEvent] = useState(null);
  const [lastSelectItem, setLastSelectItem] = useState(null);
  // useEffect(() => {
  //   Number(customPageSize) && setPageSize(Number(customPageSize));
  // }, [customPageSize, setPageSize]);
  useEffect(() => {
    Number(pageSize) && setPageSize(Number(pageSize));
  }, [setPageSize]);
// useEffect(() => {

//   setPageSize(limit); // Update when limit changes
// }, [limit]);
  const totalPages = Math.ceil(totalLength / table.getState().pagination.pageSize);
  const hasSelectedRows = () =>
    getRowModel().rows?.findIndex(
      row => row?.original?.checked === true || row?.original?.rchecked === true
    ) !== -1;
  const getVisiblePageOptions = () => {
    const startPage = Math.floor(currentPage / pagesToShow) * pagesToShow;
    const endPage = Math.min(startPage + pagesToShow - 1, totalPages - 1);

    // Generate the page numbers to display
    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const handleNext = () => {
    // if (hasSelectedRows()) {
    //   setLastAction('next');
    //   setSubmitModal(true);
    //   return false;
    // }
    if(getRowModel().rows?.findIndex(row => row?.original?.checked === true || row?.original?.rchecked === true) == -1){
    if (currentPage + pagesToShow < totalPages) {
      setCurrentPage(prevPage => prevPage + pagesToShow);
    } else {
      setCurrentPage(Math.min(getState().pagination.pageIndex + pagesToShow, totalPages - 1));
    }
    const newPageIndex = Math.min(getState().pagination.pageIndex + pagesToShow, totalPages - 1);
    setPageIndex(newPageIndex);
  }
  else{
    setLastAction('next');
  setSubmitModal(true)
   return false
  }
  };

  useEffect(() => {
// alert(table.getState().pagination.pageSize)
    if (currentPage != 0) {

      setCurrent(Number(currentPage) * table.getState().pagination.pageSize + 1)
      setPageIndex(currentPage)
    } else {
      setCurrent(Number(currentPage + 1))

    }

  }, [currentPage])

  const handlePrevious = () => {
    // if (hasSelectedRows()) {
    //   setLastAction('previous');
    //   setSubmitModal(true);
    //   return false;
    // }

    if(getRowModel().rows?.findIndex(row => row?.original?.checked === true || row?.original?.rchecked === true) == -1){
      if (currentPage - pagesToShow >= 0) {
        setCurrentPage(prevPage => prevPage - pagesToShow);
      }
      const newPageIndex = Math.max(getState().pagination.pageIndex - pagesToShow, 0);
      setPageIndex(newPageIndex);
    }
    else{
      setLastAction('previous');
      setSubmitModal(true)
     return false
    }
   
  };

  const handleSelectClick = (item) => {
    // if (hasSelectedRows()) {
    //   setLastAction('select');
    //   setLastSelectItem(item);
    //   setSubmitModal(true);
    //   return false;
    // }
    if(getRowModel().rows?.findIndex(row => row?.original?.checked === true || row?.original?.rchecked === true) == -1){
    console.log('-----', item)
    setCurrent(0)
    if (Number(item) !== 0) {
      setPageIndex(item)
      var data = item * table.getState().pagination.pageSize + 1
      setCurrent(data)
    }
    if (Number(item) === 0) {
      setPageIndex(0)
      setCurrent(1)
    }
  }
  else{
    setLastAction('select');
      setLastSelectItem(item);
    setSubmitModal(true)
   return false
  }
  };

  const Gotopage = (event) => {

    // if (hasSelectedRows()) {
    //   setLastAction('goto');
    //   setLastGotoEvent(event);
    //   setSubmitModal(true);
    //   return false;
    // }
    if(getRowModel().rows?.findIndex(row => row?.original?.checked === true || row?.original?.rchecked === true) == -1){
    if (Math.sign(event.target.value) === 1 || Math.sign(event.target.value) === 0) {
      if (Math.sign(event.target.value) !== 0) {
        setCurrentPage(event.target.value - 1)
      } else {
        setCurrentPage(1)
      }
      if (Number(event.target.value) == 1) {

        setCurrent(Number(event.target.value))
        setPageIndex(event.target.value);
      } else {

        setCurrent(Number(event.target.value - 1) * table.getState().pagination.pageSize + 1)
        setPageIndex(event.target.value - 1);
      }
    }
  }
  else{
    setLastAction('goto');
    setLastGotoEvent(event);
    setSubmitModal(true)
    return false
  }
  }

  const handleDeleteOrder = () => {
    // Clear all selections

     setSubmitModal(false);
  
    // Now trigger your original action — depending on where user came from
    // You may want to store the last action attempted in state
  
    if (lastAction === 'next') 
      {
        if (currentPage + pagesToShow < totalPages) {
          setCurrentPage(prevPage => prevPage + pagesToShow);
        } else {
          setCurrentPage(Math.min(getState().pagination.pageIndex + pagesToShow, totalPages - 1));
        }
        const newPageIndex = Math.min(getState().pagination.pageIndex + pagesToShow, totalPages - 1);
        setPageIndex(newPageIndex);
      }
    else if (lastAction === 'previous') {
      if (currentPage - pagesToShow >= 0) {
        setCurrentPage(prevPage => prevPage - pagesToShow);
      }
      const newPageIndex = Math.max(getState().pagination.pageIndex - pagesToShow, 0);
      setPageIndex(newPageIndex);
    }
    else if (lastAction === 'goto') {
      if (Math.sign(lastGotoEvent.target.value) === 1 || Math.sign(lastGotoEvent.target.value) === 0) {
        if (Math.sign(lastGotoEvent.target.value) !== 0) {
          setCurrentPage(lastGotoEvent.target.value - 1)
        } else {
          setCurrentPage(1)
        }
        if (Number(lastGotoEvent.target.value) == 1) {
  
          setCurrent(Number(lastGotoEvent.target.value))
          setPageIndex(lastGotoEvent.target.value);
        } else {
  
          setCurrent(Number(lastGotoEvent.target.value - 1) * table.getState().pagination.pageSize + 1)
          setPageIndex(lastGotoEvent.target.value - 1);
        }
      }
    }
    else if (lastAction === 'select') 
      {
        setCurrent(0)
        if (Number(lastSelectItem) !== 0) {
          setPageIndex(lastSelectItem)
          var data = lastSelectItem * table.getState().pagination.pageSize + 1
          setCurrent(data)
        }
        if (Number(lastSelectItem) === 0) {
          setPageIndex(0)
          setCurrent(1)
        }
      }
  };
  

// const onLimitChange=(newLimit)=>  {
//   setLimit(newLimit);
//   console.log("Updated limit in child:", newLimit);
// }

  return (
    <Fragment>
   <PageClickConfirmModal
        show={submitModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setSubmitModal(false)}
      />
      <Row className="mb-2">
        {isCustomPageSize && (
          <Col sm={2}>
            <select
              className="form-select pageSize mb-2"
              value={table.getState().pagination.pageSize}
              onChange={e => {
                const newLimit = Number(e.target.value);
                setLimit(newLimit);
                table.setPageSize(newLimit);
                setPageSize(newLimit); // Ensure table updates
                onLimitChange(newLimit);
              }}
            >
              {[10, 20, 30, 40, 50, 100].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        )}

        {isGlobalFilter && <DebouncedInput
          value={globalFilter ?? ''}
          onChange={value => setGlobalFilter(String(value))}
          className="form-control search-box me-2 mb-2 d-inline-block"
          placeholder={SearchPlaceholder}
        />}

        {isJobListGlobalFilter && <JobListGlobalFilter setGlobalFilter={setGlobalFilter} />}

        {isAddButton && <Col sm={6}>
          <div className="text-sm-end">
            <Button type="button" className={buttonClass} onClick={handleUserClick}>
              <i className="mdi mdi-plus me-1"></i> {buttonName}</Button>
          </div>
        </Col>}
      </Row>

      <div className={divClassName ? divClassName : "table-responsive"} style={{ maxHeight: '50vh', overflow: 'auto' }}>
        <Table hover className={tableClass} bordered={isBordered}>
          <thead className={theadClass} style={{ position: 'sticky', top: 0 }}>
            {getHeaderGroups().map(headerGroup => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map(header => {
                  return (
                    <th width={`${header.column.columnDef.width}`} key={header.id} colSpan={header.colSpan} className={`${header.column.columnDef.enableSorting ? "sorting sorting_desc" : ""}`}>
                      {header.isPlaceholder ? null : (
                        <React.Fragment>
                          <div
                            {...{
                              className: header.column.getCanSort()
                                ? 'cursor-pointer select-none'
                                : '',
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {
                              {
                                asc: '',
                                desc: '',
                              }
                              [header.column.getIsSorted()] ?? null}
                          </div>
                          {header.column.getCanFilter() ? (
                            <div>
                              <Filter column={header.column} table={table} />
                            </div>
                          ) : null}
                        </React.Fragment>
                      )}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody>
            {getRowModel().rows.map((row, index) => {
              return (
                <tr key={index}>
                  {row.getVisibleCells().map(cell => {
                    return (
//                 <td
//   className={`${cell.column.columnDef.className} ${cell.column.id === 'question' ? 'ck-content' : ''}`}
//   width={`${cell.column.columnDef.width}`}
//   key={cell.id}
// >
//   {cell.column.id === 'question' ? (
//     <div
//     width={`${cell.column.columnDef.width}`}
//       className="ck-content"
//       dangerouslySetInnerHTML={{ __html: cell.getValue() }}
//     />
//   ) : (
//     flexRender(cell.column.columnDef.cell, cell.getContext())
//   )}
// </td>

                      
                      <td className={`${cell.column.columnDef.className}`} width={`${cell.column.columnDef.width}`} key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}

          </tbody>
        </Table>
      </div>


      {
        isPagination && (
          <Row>
            <Col sm={12} md={5}>
              <div className="dataTables_info">
                Showing {Math.min(getRowModel().rows.length, getState().pagination.pageSize)} of {totalLength} Results
              </div>
            </Col>
            {/* <Col sm={12} md={4}>
              <div className="dataTables_info">
                <span className="me-2" style={{ marginTop: '2%' }}>Go to page</span> <Input
                  name="title"
                  type="text"
                  // maxLength={constants.textboxLength.c_name}
                  placeholder="page.no."
                  onChange={(e) => Gotopage(e)}
                  style={{ width: '12%' }}
                />
              </div>
            </Col> */}
            <Col sm={12} md={7}>
              <div className={paginationWrapper}>
                <ul className={pagination}>
                  {/* <div className="dataTables_info"> */}
                  <span className="me-2" style={{ marginTop: '2%' }}>Go to page</span> <Input
                    name="title"
                    type="number"
                    // maxLength={constants.textboxLength.c_name}
                    placeholder="No."
                    onChange={(e) => Gotopage(e)}
                    style={{ width: '12%' }}
                  />
                  {/* </div> */}
                  <li
                  // className={`paginate_button page-item previous ${!getCanPreviousPage() ? 'disabled' : ''}`}
                  >
                    <Link to="#" className="page-link" onClick={handlePrevious}>
                      <i className="mdi mdi-chevron-left"></i>
                    </Link>
                  </li>
                  {getVisiblePageOptions().map((item, key) => (
                    <li key={key}
                      className={`paginate_button page-item ${pageIndex === item ? 'active' : ''}`}
                    >
                      <Link
                        to="#"
                        className="page-link"
                        onClick={() => handleSelectClick(item)}
                      >
                        {item + 1}
                      </Link>
                    </li>
                  ))}
                  <li
                  // className={`paginate_button page-item next ${!getCanNextPage() ? 'disabled' : ''}`}
                  >
                    <Link to="#" className="page-link" onClick={handleNext}>
                      <i className="mdi mdi-chevron-right"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        )
      }
    </Fragment >
  );
};

export default PaginationTableContainer;